import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { CountriesService } from './@shared/services/countries.service';
import { orgThemes, ThemeService } from './@shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isAuthenticated: boolean = false;
  isInitialized = false;
  constructor(private primengConfig: PrimeNGConfig, private countriesService: CountriesService,
    private titleService: Title, private translate: TranslateService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    const orgKey = this.detectOrgFromHost(window.location.hostname);
  const theme = orgThemes[orgKey];
 
 
   this.themeService.setThemeVariables(theme);
   
    this.translate.onLangChange.subscribe((lang) => {
    
      let FoundTitle = this.translate.instant('Operation');
      this.titleService.setTitle(FoundTitle);
    });
   
   
    this.enableRipple();
    this.appInitializing();
     this.primengConfig.ripple = true;
  }
  detectOrgFromHost(host: string): string {
  if (host.includes('co41')) return 'waste';
  if (host.includes('co47')) return 'waterdistribution';
  if (host.includes('co48')) return 'waterdistribution';
   return 'default'; // keep default theme
}
  async appInitializing() {
    if (this.isInitialized) return;
    try {
      // Use a single initialization flow to avoid multiple API calls
      // Preload countries data first
      await firstValueFrom(this.countriesService.preloadCountries());
      // Only set default country if not already initialized
      await this.countriesService.setDefaultCountry();
    } catch (error) {
      console.error('Error initializing app:', error);
    }
    this.isInitialized = true;
  }

  enableRipple() {
    this.primengConfig.ripple = true;
  }
}
